import React from 'react';
import { Column } from 'react-table';
import moment from 'moment-timezone';

import SessionTable, { SessionTableInstanceProps } from '../index';
import { CellFunction, TimeCell, MethodCell, RESPONSE_NA } from '../../cells';
import Tooltip from '../../../tooltip';
import {
  IEpxEndodbMeta,
  IEpxEndodb,
  TimeOfDay
} from '../../../../../libs/apps/epxendodb';

const GetEntryValues = (session: IEpxEndodb): JSX.Element => {
  const before = session.bsBefore ? session.bsBefore : '?';
  const after = session.bsAfter ? session.bsAfter : '?';
  const insulin = session.insulin ? session.insulin : '?';
  return (
    <div>
      <span>
        {before}/{after} - ({insulin} Units)
      </span>
    </div>
  );
};

const GetTimeTooltip = (session: IEpxEndodb): JSX.Element => {
  const time = moment.tz(session.time, session.schedule?.tz).format('hh:mmA');
  let tooltip = <span>Reminder Time: {time}</span>;
  if (session.respondedAt) {
    const respondedAt = moment
      .tz(session.respondedAt, session.schedule.tz)
      .format('h:mmA');
    tooltip = (
      <span>
        {tooltip}
        <br></br>
        <span>Responded At: {respondedAt}</span>
      </span>
    );
  }
  return tooltip;
};

const EntryCell = (type: TimeOfDay): CellFunction<IEpxEndodbMeta> => {
  return ({ row: { original: session } }) => {
    const child = session[type] as IEpxEndodb;
    if (!child) {
      return RESPONSE_NA;
    }
    return (
      <Tooltip
        id={`tip-${session.id}`}
        content={<span>{GetTimeTooltip(child)}</span>}
      >
        <span>{GetEntryValues(child)}</span>
      </Tooltip>
    );
  };
};

const MultiEntryCell: CellFunction<IEpxEndodbMeta> = ({
  row: { original: session }
}) => {
  const children = session.X;
  if (!children || children.length === 0) {
    return RESPONSE_NA;
  }
  return (
    <React.Fragment>
      {children.map((child, i) => {
        const time = moment.tz(child.time, child.schedule?.tz).format('h:mmA');
        return (
          <span key={i}>
            {time} - {GetEntryValues(child)}{' '}
          </span>
        );
      })}
    </React.Fragment>
  );
};

const EpxEndodbTable: React.FC<SessionTableInstanceProps> = (
  props
): JSX.Element => {
  const columns: Column<IEpxEndodbMeta>[] = [
    {
      Header: 'Message Date',
      Cell: TimeCell('time', 'MM/DD/YYYY')
    },
    {
      Header: 'Breakfast: Pre / Post (Insulin)',
      id: 'm',
      Cell: EntryCell(TimeOfDay.M)
    },
    {
      Header: 'Lunch: Pre / Post (Insulin)',
      id: 'a',
      Cell: EntryCell(TimeOfDay.A)
    },
    {
      Header: 'Dinner: Pre / Post (Insulin)',
      id: 'e',
      Cell: EntryCell(TimeOfDay.E)
    },
    {
      Header: 'Additional Time: Pre / Post (Insulin)',
      id: 'x',
      Cell: MultiEntryCell
    },
    {
      Header: 'Msg Type',
      id: 'callIds',
      Cell: MethodCell() as CellFunction<IEpxEndodbMeta>
    }
  ];
  return (
    <SessionTable<IEpxEndodbMeta>
      url="/epxendodb/data/"
      columns={columns}
      disableDefaultColumns
      {...props}
    />
  );
};

export default EpxEndodbTable;
